import React from "react";

export default function Alert({
  severity = "info",
  children,
  className = "",
}) {
  const variants = {
    success: {
      wrapper:
        "border-green-200 bg-green-50 text-green-900",
      iconBg: "bg-green-100",
      icon: "text-green-600",
      bar: "bg-green-500",
    },
    error: {
      wrapper:
        "border-red-200 bg-red-50 text-red-900",
      iconBg: "bg-red-100",
      icon: "text-red-600",
      bar: "bg-red-500",
    },
    warning: {
      wrapper:
        "border-orange-200 bg-orange-50 text-orange-900",
      iconBg: "bg-orange-100",
      icon: "text-orange-600",
      bar: "bg-orange-500",
    },
    info: {
      wrapper:
        "border-primary-200 bg-primary-50 text-primary-900",
      iconBg: "bg-primary-100",
      icon: "text-primary-600",
      bar: "bg-primary-500",
    },
  };

  const icons = {
    success: (
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.7-9.3a1 1 0 00-1.4-1.4L9 10.6 7.7 9.3a1 1 0 00-1.4 1.4l2 2a1 1 0 001.4 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
    ),
    error: (
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2H9v-2zm0-8h2v6H9V5z"
          clipRule="evenodd"
        />
      </svg>
    ),
    warning: (
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M8.3 3.1c.8-1.4 2.7-1.4 3.5 0l5.5 9.9c.8 1.3-.2 3-1.7 3H4.5c-1.6 0-2.5-1.7-1.8-3l5.6-9.9zM10 7a1 1 0 00-1 1v3a1 1 0 102 0V8a1 1 0 00-1-1zm0 7a1.2 1.2 0 100-2.4A1.2 1.2 0 0010 14z"
          clipRule="evenodd"
        />
      </svg>
    ),
    info: (
      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M18 10A8 8 0 112 10a8 8 0 0116 0zM9 9h2v5H9V9zm0-3h2v2H9V6z"
          clipRule="evenodd"
        />
      </svg>
    ),
  };

  const style = variants[severity];

  return (
    <div
      className={`relative overflow-hidden rounded-lg border shadow-sm ${style.wrapper} ${className}`}
    >
      {/* Kolorowy pasek */}
      <div className={`absolute left-0 top-0 h-full w-1 ${style.bar}`} />

      <div className="flex gap-4 p-4">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${style.iconBg} ${style.icon}`}
        >
          {icons[severity]}
        </div>

        <div className="flex-1 text-sm leading-6">
          {children}
        </div>
      </div>
    </div>
  );
}